import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

import Home from "../views/Home.vue";
import Introduce from "../views/Introduce.vue";
import Webzine from "../views/Webzine/index.js";
import DataRoom from "../views/DataRoom/index.js";
import Gallery from "../views/Gallery.vue";
import Contact from "../views/Contact.vue";
import Error404 from "../views/Error404.vue";

Vue.use(VueRouter);

import Meta from "vue-meta"; //홈페이지 이름 설정
Vue.use(Meta, {
  title: "마을예술창작소",
});

const requireAuth = () => (to, from, next) => {
  if (store.state.user !== undefined) {
    return next();
  }
  next("/login");
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/introduce",
    name: "Introduce",
    component: Introduce,
  },
  {
    path: "/webzine",
    name: "Webzine",
    component: Webzine.Page,
  },
  {
    path: "/webzine/:webzine_id",
    name: "WebzineDetail",
    component: Webzine.Detail,
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
  },
  {
    path: "/dataroom",
    name: "DataRoom",
    component: DataRoom.Page,
  },
  {
    path: "/dataroom/:data_id",
    name: "DataRoomDetail",
    component: DataRoom.Detail,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/contact/search",
    name: "ContactSearch",
    meta: {
      search: true,
    },
    component: Contact,
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    beforeEnter: requireAuth(),
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin.vue"),
  },
  {
    path: "*",
    name: "404",
    meta: { title: `페이지를 찾을 수 없습니다.` },
    component: Error404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
